import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

import * as Icons from 'assets/icons';

import Input from "components/Input";
import Container from "components/Container";

import cls from './Hero.module.scss';
import loadingGif from 'assets/images/loading.gif';
import { message } from 'antd';
import function_register from 'assets/images/function-register.png';
// import { BuildingBank20Regular, ClipboardTaskListLtr20Regular } from '@fluentui/react-icons';

const BY_SIMILARITY = "ai-search";
const BY_PAIRS = "ai-pairs-search";

const Hero = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [clicked, setClicked] = useState(false);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);

  const popupRef = useRef(null);

  const handleNavigate = (url) => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      navigate(url);
    }, 2000);
  }

  const handleLoading = (type) => {
    if (type === BY_SIMILARITY) {
      if (search) {
        handleNavigate(`/${BY_SIMILARITY}?search=${search}`);
      } else {
        message.error(t("please_enter_function_name"));
      }
    } else {
      handleNavigate(BY_PAIRS);
    }
  }

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        setClicked(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [popupRef]);

  return (
    <section className={cls.section}>
      <Container>
        <div className={cls.content}>
          <div className={cls.hero}>
            <div className={cls.heroIcon} data-aos="fade-up">
              {/* <BuildingBank20Regular /> */}
              <img src={function_register} alt="function icon" />
            </div>
            <div data-aos="fade-up" data-aos-delay="200">
              <h1 className={cls.title}>{t('open_register_of_functions_title')}</h1>

              {/* <p className={cls.description}>{t('open_register_of_functions_description')}</p> */}
            </div>
          </div>

          {/*<a className={cls.enter} href={config.app.partner_url} target='_blank'>*/}
          {/*  {t('action_enter')}*/}
          {/*</a>*/}

          <div className={cls.search}>
            <div
              data-aos="fade-in" data-aos-delay="300"
            >
              <Input
                onChange={e => setSearch(e)}
                onKeyPress={e => {
                  if (e.key === 'Enter') {
                    navigate(`/function-register?function_name=${search}`);
                  }
                }}
                placeholder={t('search_by_function_name')}
                value={search}
                size="large"
              />
              <div
                className={cls.icon}
                onClick={() => navigate(`/function-register?function_name=${search}`)}
              >
                <Icons.Search />
              </div>
              <div
                className={cls.aiIcon}
                onClick={() => setClicked(prev => !prev)}
                title={t("ai-search")}
                ref={popupRef}
              >
                {
                  loading ? <img className={cls.aiLoading} src={loadingGif} /> : <Icons.Ai />
                }
                {
                  clicked && <div className={cls.searchPopup}>
                    <div className={cls.searchPopupItem} onClick={() => handleLoading(BY_SIMILARITY)}>{t("ai-search-by-similarity")}</div>
                    <div className={cls.searchPopupItem} onClick={() => handleLoading(BY_PAIRS)}>{t("ai-search-by-pairs")}</div>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      </Container>
    </section>
  )
}

export default Hero;